import { h } from 'preact';
import ADIcon from './icon-components/ADIcon';
import BackLiveIcon from './icon-components/BackLiveIcon';
import BackStartIcon from './icon-components/BackStartIcon';
import CheckIcon from './icon-components/CheckIcon';
import HDIcon from './icon-components/HDIcon';
import HeartActiveIcon from './icon-components/HeartActiveIcon';
import HeartIcon from './icon-components/HeartIcon';
import InfosActiveIcon from './icon-components/InfosActiveIcon';
import InfosIcon from './icon-components/InfosIcon';
import LeftArrowIcon from './icon-components/LeftArrowIcon';
import Minus10Icon from './icon-components/Minus10Icon';
import NextIcon from './icon-components/NextIcon';
import PauseIcon from './icon-components/PauseIcon';
import PauserollResumeDarkIcon from './icon-components/PauserollResumeDarkIcon';
import PauserollResumeIcon from './icon-components/PauserollResumeIcon';
import PlayIcon from './icon-components/PlayIcon';
import Plus10Icon from './icon-components/Plus10Icon';
import PreviousIcon from './icon-components/PreviousIcon';
import ReplayIcon from './icon-components/ReplayIcon';
import RightArrowIcon from './icon-components/RightArrowIcon';
import SDIcon from './icon-components/SDIcon';
import SMEIcon from './icon-components/SMEIcon';
import StopIcon from './icon-components/StopIcon';
import Text10Icon from './icon-components/Text10Icon';

export const COMMON_ICONS = (props) => ({
  play: <PlayIcon {...props} />,
  replay: <ReplayIcon {...props} />,
  pause: <PauseIcon {...props} />,
  stop: <StopIcon {...props} />,
  rewind: <Minus10Icon {...props} />,
  text10: <Text10Icon {...props} />,
  'back-to-live': <BackLiveIcon {...props} />,
  'back-to-start': <BackStartIcon {...props} />,
  next: <NextIcon {...props} />,
  'right-arrow': <RightArrowIcon {...props} />,
  'left-arrow': <LeftArrowIcon {...props} />,
  check: <CheckIcon {...props} />,
  ad: <ADIcon {...props} />,
  sme: <SMEIcon {...props} />,
  sd: <SDIcon {...props} />,
  hd: <HDIcon {...props} />,
  pauserollPlay: <PauserollResumeIcon {...props} />,
  pauserollPlayDark: <PauserollResumeDarkIcon {...props} />,
  previous: <PreviousIcon {...props} />,
  heart: <HeartIcon {...props} />,
  'heart-active': <HeartActiveIcon {...props} />,
  infos: <InfosIcon {...props} />,
  'infos-active': <InfosActiveIcon {...props} />,
  forward: <Plus10Icon {...props} />
});
